import LazyLoad from 'vanilla-lazyload';

import setupCSRFToken from './setupCSRFToken';
import setupRedirects from './setupRedirects';

declare global {
  interface Window {
    lazyLoadInstance: InstanceType<typeof LazyLoad>;
  }
}

setupCSRFToken();
setupRedirects();

window.lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
});
